<template>
	<div class="publicBox centerBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>账户信息</li>
			</ul>
		</div>
		<div class="desBox">
			<div class="name flexBox">
				<img src="../../../assets/img/admin/icon_0.png" class="icon">
				<p class="txt">用户：</p>
				<p class="val">{{userData && userData.username ? userData.username : ""}}</p>
			</div>
			<div class="time">您的上次登录时间：{{userData && userData.loginTime ? userData.loginTime : ""}}</div>
		</div>

		<div class="setBox">
			<div class="name">账户设置：</div>
			<ul class="setList">
				<li class="flexBox">
					<img src="../../../assets/img/admin/icon_1.png" class="icon">
					<p class="txt">绑定手机</p>
					<p class="val">您当前绑定的手机号为：{{phone}}。绑定后可用于手机找回密码、接收手机动态验证码等，使您的账户更加安全。</p>
					<div class="btn" @click="() => editPhone = true">修改</div>
				</li>
				<li class="flexBox">
					<img src="../../../assets/img/admin/icon_2.png" class="icon">
					<p class="txt">绑定邮箱</p>
					<p class="val">您当前绑定的邮箱为：{{email == "cloud-service@zminfra.cn"?"--":email}}。验证后可用于找回密码、接收提醒等，保障您的账户更加安全。</p>
					<div class="btn" @click="showEmailModal">{{email == "cloud-service@zminfra.cn"?"绑定":"修改"}}</div>
				</li>
				<li class="flexBox">
					<img src="../../../assets/img/admin/icon_3.png" class="icon">
					<p class="txt">登录密码</p>
					<p class="val">安全性高的密码可以使帐号更安全。建议您定期更换密码，设置一个包含字母、符号、数字组成且长度不少于6位的密码。</p>
					<div class="btn" @click="() => editPwd = true">修改</div>
				</li>
				
			</ul>
		</div>


		<a-modal class="publicModel" :width="'48rem'" :closable="model.close" :visible="editPwd"
			:centered="model.center">
			<div class="titleBox">
				<div class="item">修改密码</div>
				<div class="close" @click="() => editPwd = false">
					<a-icon type="close" />
				</div>
			</div>
			<a-form-model class="formBox" :model="pwdForm">
				<a-form-model-item>
					<a-input-password v-model="pwdForm.old" placeholder="请输入当前密码" />
				</a-form-model-item>
				<a-form-model-item>
					<a-input-password v-model="pwdForm.password" placeholder="请输入新密码" />
				</a-form-model-item>
				<a-form-model-item>
					<a-input-password v-model="pwdForm.sure" placeholder="请再次输入新密码" />
				</a-form-model-item>
				<a-button class="btn" @click="clickPwd">确认修改</a-button>
			</a-form-model>
		</a-modal>


		<a-modal class="publicModel" :width="'48rem'" :closable="model.close" :visible="editPhone"
			:centered="model.center">
			<div class="titleBox">
				<div class="item">修改手机号码</div>
				<div class="close" @click="() => editPhone = false">
					<a-icon type="close" />
				</div>
			</div>
			<a-form-model class="formBox" :model="phoneForm">
				<a-form-model-item>
					<a-input v-model="phoneForm.phone" placeholder="请输入新的手机号" />
				</a-form-model-item>
				<a-form-model-item class="flex">
					<a-input v-model="phoneForm.code" placeholder="请输入验证码" />
					<div class="codeBox" :class="state == 1 ? 'edit':''" @click="clickCode">
						<template v-if="state == 0">
							发送验证码
						</template>
						<template v-else-if="state == 1">
							{{time}}
						</template>
						<template v-else-if="state == 2">
							重新发送
						</template>
					</div>
				</a-form-model-item>
				<a-button class="btn" @click="clickPhone">确认修改</a-button>
			</a-form-model>
		</a-modal>

		<!-- 邮箱模态框组件 -->
		<email-modal 
			v-model="editEmail" 
			:type="emailModalType"
			@success="handleEmailSuccess"
		/>
		
	</div>
</template>
<script>
	import GlobalInfo from '../../../components/GlobalInfo.vue';
	import EmailModal from '../../../components/com/EmailModal.vue';
	export default {
		name: 'Center',
		components: {
			EmailModal
		},
		data() {
			return {
				phone: "",
				email:"",
				model: {
					close: false,
					center: true,
				},
				editPwd: false,
				pwdForm: {},
				editPhone: false,
				phoneForm: {},
				state: 0,
				timer: 0,
				time: 10,
				editEmail: false,
				emailModalType: 'edit', // 'edit' 或 'bind'
				userData:null,
			}
		},
		mounted() {
			this.$tools.getUserInfo(
				(data) => {
					this.userData = data;
					this.email=this.userData.email;
					this.phone=this.$tools.covnStr(2, this.userData.phone + "");
				}
			);
		},
		beforeDestroy() {
			// 清理定时器
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			clickPwd() {
				if (!this.pwdForm.old || this.pwdForm.old === "") {
					this.$message.error("请输入旧密码");
					return
				};

				if (!this.pwdForm.password || this.pwdForm.password === "") {
					this.$message.error("请输入新密码");
					return
				};

				if (this.pwdForm.password != this.pwdForm.sure) {
					this.$message.error("请再次输入新密码");
					return
				};
				this.$reqToken("post", "/sso/updatePassword", this.pwdForm).then((res) => {
					if(res.code&&res.code==200){
						this.$message.success("修改密码成功");
						this.editPwd = false;
						this.pwdForm={};
					}else{
						this.$message.error(res.msg);
					}
				})


			},
			clickCode() {
				switch (this.state) {
					case 0:
					case 2:
						this.$reqToken("post", "/sso/sendVc", this.phoneForm).then((res) => {
							if(res.code&&res.code==200){
								this.$message.success("发送成功");
								this.state = 1;
								this.time = 60;
								this.timer = setInterval(() => {
									this.time--;
									if (this.time <= 0) {
										window.clearInterval(this.timer)
										this.state = 2;
									};
								}, 1000)
							}else{
								this.$message.error(res.msg);
							}
						})
						break;
				}
			},
			clickPhone() {
				if (!/^1[3456789]\d{9}$/.test(this.phoneForm.phone)) {
					this.$message.error("请输入手机号");
					return
				};

				if (!this.phoneForm.code || this.phoneForm.code === "") {
					this.$message.error("请输入验证码");
					return
				};
				this.$reqToken("post", "/sso/updatePhone", this.phoneForm).then((res) => {
					if(res.code&&res.code==200){
						this.$message.success("修改手机号成功");
						this.editPhone = false;
						this.phoneForm={};
						this.$tools.getUserInfo(
							(data) => {
								this.userData = data;
								this.phone=this.$tools.covnStr(2, this.userData.phone + "");
							}
						);
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			showEmailModal() {
				// 根据当前邮箱状态判断是修改还是绑定操作
				this.emailModalType = this.email == "cloud-service@zminfra.cn" ? 'bind' : 'edit';
				this.editEmail = true;
			},
			handleEmailSuccess() {
				// 邮箱操作成功后的回调函数
				// 更新用户信息
				this.$tools.getUserInfo(
					(data) => {
						this.userData = data;
						this.email = this.userData.email;
					}
				);
			}
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/admin/center.css");
	@import url("../../../assets/css/admin/admin.css");
</style>